import { InfoIcon } from 'lucide-react';

import type { CellRendererParams } from '@/grid/types';
import { cn } from '@/lib/utils';
import { ValidationMessageLevel } from '@/services/bulk-donor-schedule';

import type { Messages } from '../hooks/use-bulk-donor-schedule-store';

type CellRendererContext = {
  type: string;
  errors: Record<string, string> | undefined;
  messages: Messages | undefined;
  warningRowIndexes: ReadonlySet<number>;
};

export function CellRenderer<Row>({
  value,
  valueFormatted,
  context,
  colDef,
  node,
}: CellRendererParams<Row> & { context: CellRendererContext }) {
  const field = colDef?.field;
  const name =
    field && node.rowIndex !== null ? `${node.rowIndex}.${field}` : undefined;
  const error = name && context.errors?.[name];
  const message = name && context.messages?.[name];
  const displayValue = valueFormatted ?? value;

  if (!error && !message) {
    return displayValue;
  }

  const isWarningRow =
    node.rowIndex !== null && context.warningRowIndexes.has(node.rowIndex);
  const iconColor = error
    ? 'text-red-500'
    : context.type === 'success'
      ? isWarningRow
        ? 'text-amber-500'
        : 'text-emerald-500'
      : message?.level === ValidationMessageLevel.WARNING
        ? 'text-amber-500'
        : 'text-emerald-500';

  return (
    <>
      <span className="min-w-0 truncate">{displayValue?.toString() ?? ''}</span>
      <InfoIcon className={cn('size-3.5 shrink-0', iconColor)} />
    </>
  );
}
